import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import ApprovalForm from './dynamic-form/ApprovalForm';
import ApprovalElement from './dynamic-report/ApprovalElement';

class ReportApproval extends Component {
  // ----------------------
  // Computed
  // ----------------------

  get showApproval() {
    return this.props.report.approvedOneAt;
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <Fragment>
        {this.props.report.getCanApprove(this.props.userContext.scope) &&
          <ApprovalForm reportGuid={this.props.report.guid} />
        }
        {this.showApproval &&
          <ApprovalElement
            approvedOneAt={this.props.report.approvedOneAt}
            approvedOneBy={this.props.report.getFullNameFor('approverOne')}
            approveCommentOne={this.props.report.approveCommentOne}
          />
        }
      </Fragment>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    userContext: state.common.userContext,
  };
};

export default connect(mapStateToProps, null)(ReportApproval);
